import { RangePicker } from 'antd/lib/date-picker'
import moment from 'moment'
import React, { Component } from 'react'
import { ranges, getStartAndEndTime } from './constant'
import 'antd/lib/date-picker/style/index.css'
import 'antd/lib/input/style/index.css'
import 'antd/lib/time-picker/style/index.css'
import 'antd/lib/tag/style/index.css'
import LocaleProvider from 'antd/lib/locale-provider'
import zhCN from 'antd/lib/locale-provider/zh_CN';

const mapDefaultToValue = (defaultValue = 'seven_days') => {
  if (Array.isArray(defaultValue)) {
    return defaultValue
  }
  const ret =
    typeof defaultValue === 'string'
      ? getStartAndEndTime(defaultValue)
      : defaultValue
  return [
    ret && ret.start ? moment(ret.start) : moment(new Date()),
    ret && ret.end ? moment(ret.end) : moment(new Date())
  ]
}
const mapValuetoValue = value => ({
  start: +value[0],
  end: +value[1]
})

export default class TimeRangePicker extends Component {
  state = {
    value: mapDefaultToValue(this.props.defaultValue, this.props)
  }
  componentWillReceiveProps(nextProps) {
    const { defaultValue, reset } = this.props
    const { defaultValue: d } = nextProps
    if (d !== defaultValue || reset) {
      this.setState({
        value: mapDefaultToValue(d)
      })
    }
  }
  handleChange = (value) => {
    const { onChange } = this.props
    this.setState({
      value
    })
    onChange && onChange(mapValuetoValue(value))
  }
  handleOk = () => {
    const { onChange } = this.props
    setTimeout(() => {
      onChange && onChange(mapValuetoValue(this.state.value))
    }, 0);
  }
  render() {
    const { value } = this.state
    const { style = {}, ...others } = this.props

    return (
      <LocaleProvider locale={zhCN}>
        <RangePicker
          ranges={ranges}
          showTime={{
            format: 'HH:mm'
          }}
          style={{
            ...style,
            width: style.width || '100%'
          }}
          value={value}
          format="YYYY-MM-DD HH:mm"
          onOk={this.handleOk}
          {...others}
          onChange={this.handleChange}
        />
      </LocaleProvider>
    )
  }
}
